<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-28 09:51:42
 * @FilePath: \YunYin_admin\src\views\Setting\BusinessArea\components\RightTable.vue
-->
<template>
  <div class="right-table">
    <div class="right-header">
      <span class="area-info">{{
        `${current ? current.zoneName : ""} (${personList.length}人)`
      }}</span>
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          class="add-btn"
          @click="addPerson"
          >添加业务员</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="delete-btn"
          @click="deletePerson"
          >删除业务员</el-button
        >
      </div>
    </div>
    <el-table
      class="person-table"
      ref="multipleTable"
      :data="personList"
      @selection-change="selectionChange"
      >>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="personName"
        label="名字"
        min-width="190"
        align="center"
      >
        <template slot-scope="scope">
          <span class="person-name"
            >{{ scope.row.personName }}
            <span class="duty-flag" v-show="scope.row.dutyFlag">
              <span>负责人</span>
            </span></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="300" align="center">
      </el-table-column>
    </el-table>
    <CurrentDialog
      v-if="showDialog"
      :showDialog="showDialog"
      :dialogObj="dialogObj"
      :multipleSelection="multipleSelection"
      :areaData="current"
      :businessZoneList="businessZoneList"
      @close="close"
      @getPersonListbyZoneId="getPersonListbyZoneId"
    ></CurrentDialog>
  </div>
</template>

<script>
import CurrentDialog from "./CurrentDialog";
export default {
  name: "RightTable",
  props: {
    current: {
      type: Object,
      default: {},
    },
  },
  components: {
    CurrentDialog,
  },
  data() {
    return {
      personList: [], // 业务员列表
      showDialog: false, // 弹窗展示
      dialogObj: {}, // 弹框类型
      // 弹窗信息
      handles: {
        add: { label: "添加业务员", id: 8, w: "500px", btn: "确认" },
        delete: { label: "删除业务员", id: 10, w: "400px", btn: "删除" },
      },
      multipleSelection: [], // 表格选中
      businessZoneList: [], // 区域列表
    };
  },
  methods: {
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 获取业务员列表
     * @Author: yangsibo
     * @Date: 2022-05-12 14:35:20
     * @param {*} id 区域id
     * @return {*}
     */
    async getPersonListbyZoneId(id) {
      try {
        let { data } = await this.$http.business.getPersonListbyZoneId({
          businessZoneId: id,
        });
        this.personList = data ? data : [];
      } catch (error) {}
    },
    /**
     * @description: 批量添加业务员
     * @Author: yangsibo
     * @Date: 2022-05-12 15:50:48
     */
    addPerson() {
      this.handleDialog(this.handles.add);
    },
    /**
     * @description: 批量删除业务员
     * @Author: yangsibo
     * @Date: 2022-05-12 15:50:48
     */
    deletePerson() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请至少选中一个业务员",
          duration: 2000,
        });
        return;
      }
      this.handleDialog(this.handles.delete);
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-05-13 17:42:26
     */
    handleDialog(item) {
      this.dialogObj = item;
      this.showDialog = true;
    },
  },
  created() {},
  mounted() {},
  watch: {
    current: {
      handler(val) {
        if (val) {
          this.getPersonListbyZoneId(val.id);
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.right-table {
  .right-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .area-info {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
    }
    .handle-btn {
      padding: 10px;
    }
  }
  .person-table {
    margin: 12px 0;
    ::v-deep .cell {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .person-name {
        position: relative;
        .duty-flag {
          display: inline-block;
          background: url("~@/assets/kuang_fuzeren.png");
          width: 64px;
          height: 26px;
          text-align: center;
          position: absolute;
          left: calc(100% + 8px);
          span {
            display: inline-block;
            position: absolute;
            top: 50%;
            right: 11%;
            transform: translate(0, -50%);
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            height: 100%;
          }
        }
      }
    }
  }
  .right-footer {
  }
}
</style>
